// src/components/hooks/useDiccionario.ts
import { useEffect, useState, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { supabase } from '@/lib/supabaseClient';

export type CampoDiccionario = {
  tabla: string;
  columna: string;
  descripcion_columna: string | null;
};

export const useDiccionario = (tabla: string) => {
  const [campos, setCampos] = useState<CampoDiccionario[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchCampos = useCallback(async () => {
    if (!tabla) return;

    setLoading(true);

    const { data, error } = await supabase
      .from('vista_diccionario_bd_columnas')
      .select('tabla, columna, descripcion_columna')
      .eq('tabla', tabla);

    if (error) {
      Sentry.captureException(error, { extra: { tabla } }); // 👈
    } else {
      setCampos(data);
    }

    setLoading(false);
  }, [tabla]);

  useEffect(() => {
    fetchCampos();
  }, [fetchCampos]);

  return { campos, loading };
};

export const useDescripcionTabla = (tabla: string) => {
  const [descripcion, setDescripcion] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchDescripcion = useCallback(async () => {
    if (!tabla) return;

    setLoading(true);

    const { data, error } = await supabase
      .from('vista_diccionario_bd_tablas')
      .select('descripcion_tabla')
      .eq('tabla', tabla)
      .single();

    if (error) {
      Sentry.captureException(error, { extra: { tabla } }); // 👈
    } else {
      setDescripcion(data.descripcion_tabla);
    }

    setLoading(false);
  }, [tabla]);

  useEffect(() => {
    fetchDescripcion();
  }, [fetchDescripcion]);

  return { descripcion, loading };
};
